import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ACTIVE_CLINIC_KEY = "pawfile.active-clinic-id";

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const clinicId = window.sessionStorage.getItem(ACTIVE_CLINIC_KEY);
  if (clinicId) {
    config.headers = config.headers || {};
    config.headers["X-Pawfile-Clinic-Id"] = clinicId;
  }
  return config;
});

export const API_URL = `${BACKEND_URL}/api`;

export function getActiveClinicId() {
  return window.sessionStorage.getItem(ACTIVE_CLINIC_KEY);
}

export function setActiveClinicId(clinicId) {
  if (clinicId) {
    window.sessionStorage.setItem(ACTIVE_CLINIC_KEY, clinicId);
  }
}

export function clearActiveClinicId() {
  window.sessionStorage.removeItem(ACTIVE_CLINIC_KEY);
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
  }
  return String(detail);
}
